import React, { useState, useEffect, useRef } from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import PrintIcon from "@material-ui/icons/Print";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import moment from "moment";
import BiztranControls from "../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../hooks/UseFetchData"
import Modal_Frame from "../biztran_controls/Modal_Frame";
import { DatePickerInput } from 'rc-datepicker';
import Session from "react-session-api";
import { Save } from "@material-ui/icons";
import { v4 as uuidv4 } from 'uuid';


const todate = new Date()
const fromdate = todate.getFullYear() - 1 + '/04/01';

// function useApiRef() {
//   const apiRef = useRef(null);
//   const _columns = useMemo(
//     () =>
//       columns.concat({
//         field: "__HIDDEN__",
//         width: 0,
//         renderCell: (params) => {
//           apiRef.current = params.api;
//           return null;
//         },
//       }),
//     [columns]
//   );
//   return { apiRef, columns: _columns };
// }

const AddExpense = (props) => {
    //debugger;
    //const classes = useStyles();
    const [TravelRequestNo, setTravelRequestNo] = useState('');
    const [ExpenseID, setExpenseID] = useState(props.ExpenseID != '' ? props.ExpenseID : uuidv4());
    const [TravelRequestID, setTravelRequestID] = useState('');
    const [TravelRequestDate, setTravelRequestDate] = useState('');
    const [UserName, setUserName] = useState('');
    const [LocationToTravel, setLocationToTravel] = useState('');
    const [PurposeOfTravel, setPurposeOfTravel] = useState('');
    const [ExpenseSheetCreatedOn, setExpenseSheetCreatedOn] = useState('');
    const [ExpenseDate, setExpenseDate] = useState();
    const [ExpenseTypecmb, setExpenseTypecmb] = useState([]);
    const [ModeOfTravelcmb, setModeOfTravelcmb] = useState([]);
    const [EmpID, setEmpID] = useState('');
    const [Status, setStatus] = useState('');
    const [EmpName, setEmpName] = useState('');
    const [CityType, setCityType] = useState('');
    const [AccountsApprovedByID, setAccountsApprovedByID] = useState(Session.get("UID"));
    const [PaidAmount, setPaidAmount] = useState('');
    const [AccountsApprovedOn, setAccountsApprovedOn] = useState('')
    const [TravelFrom, setTravelFrom] = useState('');
    const [ModeOfTravelID, setModeOfTravelID] = useState('');
    const [ApprovedBy, setApprovedBy] = useState('');
    const [ApprovedOn, setApprovedOn] = useState('');
    const [AccApprovedBy, setAccApprovedBy] = useState(Session.get("UserName"));
    const [responseList, ListfetchData] = UseFetchData();
    const [AccApprovedOn, setAccApprovedOn] = useState('');
    const [PlannedAmount, setPlannedAmount] = useState('');
    const [tolExpAmount, settolExpAmount] = useState('');
    const [ExpenseType, setExpenseType] = useState('');
    const [ExpenseTypeID, setExpenseTypeID] = useState('');
    const [CheckInDate, setCheckInDate] = useState('');
    const [CheckOutDate, setCheckOutDate] = useState('');
    const [NoOfDays, setNoOfDays] = useState('');
    const [TravelMode, setTravelMode] = useState('');
    const [Distance, setDistance] = useState('');
    const [Time, setTime] = useState('');
    const [ExpAmount, setExpAmount] = useState('');
    const [UpperLimit, setUpperLimit] = useState('');
    const [TravelTo, setTravelTo] = useState('');
    const [ApproveAmt, setApproveAmt] = useState('');
    const [Remarks, setRemarks] = useState('');
    const [ProjectCode, setProjectCode] = useState('');
    const [responseattachment, attachmentfetchData] = UseFetchData();
    const [Expensecmb, setExpensecmb] = useState([]);
    const [SelectedPdf, setSelectedpdf] = useState(null);
    const [PdfUploaded, setPdfUploaded] = useState(0);
    const [MainState, setMainState] = useState('initial');

    const [tolExpAppAmount, settolExpAppAmount] = useState('');
    const [tolAccAppAmount, settolAccAppAmount] = useState('');

    const [PaidOn, setPaidOn] = useState('');
    const [pagename, setpagename] = useState(props.pagename);
    const [flag, setflag] = useState(props.pagename == "Home" ? true : true);
    const [flag01, setflag01] = useState(false);
    const [Delflag, setDelflag] = useState(true);
    const [saveflag, setSaveflag] = useState(false);
    // console.log(props.poppopupData.[FunctionLocation);
    const [TotalPaidAmount, setTotalPaidAmount] = useState('');
    const [PaymentDetails, setPaymentDetails] = useState('');
    const [rows, setRows] = useState([]);
    const [LocationFromTravel, setTravelFromLocation] = useState([]);
    const [columns, setColumns] = useState([]);
    const [response, fetchData] = UseFetchData();
    const [responseAccAp, AccApfetchData] = UseFetchData();
    const [response01, fetchData01] = UseFetchData();
    const [responseprint, fetchDataprint] = UseFetchData();
    const [responseApprove, fetchDataapprove] = UseFetchData();
    const [responseReject, fetchDataReject] = UseFetchData();
    const [responseExpType, fetchExpTypeData] = UseFetchData();
    const [responseModeOfTravel, fetchModeOfTravel] = UseFetchData();
    const [responseFile, fetchDataFile] = UseFetchData();
    const [responseDeleteFile, fetchdeleteFile] = UseFetchData();
    // const fromdate = new Date()
    const [ToDate, setToDate] = useState('');
    const [FromDate, setFromDate] = useState('');
    const [Description, setDescription] = useState('');
    const [ApproxExpAmt, setApproxExpAmt] = useState('');
    const [defaultToDate, setdefaultToDate] = useState('');
    const [ReasonToRejection, setReasonToRejection] = useState('');
    const [ApprovalStatus, setApprovalStatus] = useState([]);

    const [At1File, setAT1File] = useState(null);
    const [At2File, setAT2File] = useState(null);
    const [At3File, setAT3File] = useState(null);
    const [At1URL, setAt1URL] = useState(null);
    const [At2URL, setAt2URL] = useState(null);
    const [At3URL, setAt3URL] = useState(null);
    const [At1ID, setAt1ID] = useState(null);
    const [At2ID, setAt2ID] = useState(null);
    const [At3ID, setAt3ID] = useState(null);
    const [At1, setAt1] = useState('');
    const [DisableKM, setDisableKM] = useState(false);
    // Add state for time part
    const [TimeReached, setTimeReached] = useState('');
    // Add this with your other state declarations
    const [ExpenseTime, setExpenseTime] = useState('');

    const poppopupData = () => {
        //debugger;
        // const bodyFormData = new FormData();
        // bodyFormData.append("TravelRequestID", props.TravelRequestID);
        // ListfetchData("Dashboard/GetbyID", bodyFormData);
        const bodyFormData = new FormData();
        bodyFormData.append("ExpenseID", ExpenseID);
        bodyFormData.append("TravelRequestID", props.TravelRequestID);
        bodyFormData.append("EmpID", Session.get("UID"));
        ListfetchData("ExpMangt/ExpenseListWeb", bodyFormData)
    }

    useEffect(() => {
        debugger;
        if (responseFile != '' || responseFile != undefined) {
            if (responseFile.Response == true) {
                debugger;
                alert('File Uploaded Succesfully.');
                //setTravelReportFile('TravelReportUploaded');
            } else if (responseFile.Response == false) {
                debugger;
                alert('File Uploaded Failed.');

            }
        }
    }, [responseFile])



    const popupGrid = () => {
        debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("TravelRequestID", props.TravelRequestID);
        fetchData("Dashboard/ExpenseList", bodyFormData);

    }

    const validationSchema = Yup.object({
        TravelFrom: Yup.string().required("Required!"),

    });

    const CityTypeOptions = [
        { key: "Capital City", value: "Capital City" },
        { key: "Non Capital City", value: "Non Capital City" },

    ];

    //const submitApprove = () => {
    const onSubmit = () => {
        debugger;
        const bodyFormData = new FormData();
        if (ExpenseTypeID == '3b06fd98-4b7e-11ed-ad55-42010aa00007' || ExpenseTypeID == '18f3120b-6eee-11ed-8023-42010aa00007') {
            if ((TravelFrom != null && TravelFrom != "") && (TravelTo != null && TravelTo != "")) {
                if (props.ExpenseID == '') {
                    bodyFormData.append("ExpenseID", ExpenseID);
                    bodyFormData.append("TravelRequestID", props.TravelRequestID);
                    bodyFormData.append("EmpID", Session.get("UID") ?? "");
                    // bodyFormData.append("ExpenseDate", ExpenseDate);
                    const combinedDateTime1 = ExpenseDate && ExpenseTime ? 
                     `${ExpenseDate} ${ExpenseTime}` : ExpenseDate;
                    bodyFormData.append("ExpenseDate", combinedDateTime1);
                    bodyFormData.append("ExpenseTypeID", ExpenseTypeID);
                    bodyFormData.append("ModeOfTravelID", ModeOfTravelID);
                    bodyFormData.append("TravelFrom", TravelFrom);
                    bodyFormData.append("TravelTo", TravelTo);
                    bodyFormData.append("DistanceTravelledInKm", Distance);
                    // bodyFormData.append("TimeTakenInHrs", Time);
                    const combinedDateTime = Time && TimeReached ? 
                    `${Time} ${TimeReached}` : Time;
                    bodyFormData.append("TimeTakenInHrs", combinedDateTime);
                    bodyFormData.append("HotelStarRatingID", '');
                    bodyFormData.append("HotelName", '');
                    bodyFormData.append("CheckInDate", CheckInDate);
                    bodyFormData.append("CheckOutDate", CheckOutDate);
                    bodyFormData.append("NoOfDaysStayed", NoOfDays);
                    bodyFormData.append("ExpenseAmount", ExpAmount);
                    bodyFormData.append("ProjectCode", ProjectCode);
                    bodyFormData.append("Remarks", Remarks);
                    bodyFormData.append("UpperCeiling", UpperLimit);
                    bodyFormData.append("CityType", CityType);
                    fetchDataapprove("ExpMangt/ExpensesSaveWeb", bodyFormData);
                } else {
                    bodyFormData.append("ExpenseID", ExpenseID);
                    bodyFormData.append("TravelRequestID", props.TravelRequestID);
                    bodyFormData.append("EmpID", Session.get("UID"));
                    // bodyFormData.append("ExpenseDate", ExpenseDate);
                    const combinedDateTime1 = ExpenseDate && ExpenseTime ? 
                    `${ExpenseDate} ${ExpenseTime}` : ExpenseDate;
                    bodyFormData.append("ExpenseDate", combinedDateTime1);
                    bodyFormData.append("ExpenseTypeID", ExpenseTypeID);
                    bodyFormData.append("ModeOfTravelID", ModeOfTravelID);
                    bodyFormData.append("TravelFrom", TravelFrom);
                    bodyFormData.append("TravelTo", TravelTo);
                    bodyFormData.append("DistanceTravelledInKm", Distance);
                    // bodyFormData.append("TimeTakenInHrs", Time);
                    const combinedDateTime = Time && TimeReached ? 
                    `${Time} ${TimeReached}` : Time;
                    bodyFormData.append("TimeTakenInHrs", combinedDateTime);
                    bodyFormData.append("HotelStarRatingID", '');
                    bodyFormData.append("HotelName", '');
                    bodyFormData.append("CheckInDate", CheckInDate);
                    bodyFormData.append("CheckOutDate", CheckOutDate);
                    bodyFormData.append("NoOfDaysStayed", NoOfDays);
                    bodyFormData.append("ExpenseAmount", ExpAmount);
                    bodyFormData.append("ProjectCode", ProjectCode);
                    bodyFormData.append("Remarks", Remarks);
                    bodyFormData.append("UpperCeiling", UpperLimit);
                    bodyFormData.append("CityType", CityType);
                    fetchDataapprove("ExpMangt/ExpensesUpdateWeb", bodyFormData);
                }
            }
            else {
                alert("Please add travel from and to");
            }
        }
        else {
            if (props.ExpenseID == '') {
                bodyFormData.append("ExpenseID", ExpenseID);
                bodyFormData.append("TravelRequestID", props.TravelRequestID);
                bodyFormData.append("EmpID", Session.get("UID"));
                // bodyFormData.append("ExpenseDate", ExpenseDate);
                const combinedDateTime1 = ExpenseDate && ExpenseTime ? 
                `${ExpenseDate} ${ExpenseTime}` : ExpenseDate;
                bodyFormData.append("ExpenseDate", combinedDateTime1);
                bodyFormData.append("ExpenseTypeID", ExpenseTypeID);
                bodyFormData.append("ModeOfTravelID", ModeOfTravelID);
                bodyFormData.append("TravelFrom", TravelFrom);
                bodyFormData.append("TravelTo", TravelTo);
                bodyFormData.append("DistanceTravelledInKm", Distance);
                // bodyFormData.append("TimeTakenInHrs", Time);
                const combinedDateTime = Time && TimeReached ? 
                `${Time} ${TimeReached}` : Time;
                bodyFormData.append("TimeTakenInHrs", combinedDateTime);
                bodyFormData.append("HotelStarRatingID", '');
                bodyFormData.append("HotelName", '');
                bodyFormData.append("CheckInDate", CheckInDate);
                bodyFormData.append("CheckOutDate", CheckOutDate);
                bodyFormData.append("NoOfDaysStayed", NoOfDays);
                bodyFormData.append("ExpenseAmount", ExpAmount);
                bodyFormData.append("ProjectCode", ProjectCode);
                bodyFormData.append("Remarks", Remarks);
                bodyFormData.append("UpperCeiling", UpperLimit);
                bodyFormData.append("CityType", CityType);
                fetchDataapprove("ExpMangt/ExpensesSaveWeb", bodyFormData);
            } else {
                bodyFormData.append("ExpenseID", ExpenseID);
                bodyFormData.append("TravelRequestID", props.TravelRequestID);
                bodyFormData.append("EmpID", Session.get("UID"));
                // bodyFormData.append("ExpenseDate", ExpenseDate);
                const combinedDateTime1 = ExpenseDate && ExpenseTime ? 
                `${ExpenseDate} ${ExpenseTime}` : ExpenseDate;
                bodyFormData.append("ExpenseDate", combinedDateTime1);
                bodyFormData.append("ExpenseTypeID", ExpenseTypeID);
                bodyFormData.append("ModeOfTravelID", ModeOfTravelID);
                bodyFormData.append("TravelFrom", TravelFrom);
                bodyFormData.append("TravelTo", TravelTo);
                bodyFormData.append("DistanceTravelledInKm", Distance);
                // bodyFormData.append("TimeTakenInHrs", Time);
                const combinedDateTime = Time && TimeReached ? 
                `${Time} ${TimeReached}` : Time;
                bodyFormData.append("TimeTakenInHrs", combinedDateTime);
                bodyFormData.append("HotelStarRatingID", '');
                bodyFormData.append("HotelName", '');
                bodyFormData.append("CheckInDate", CheckInDate);
                bodyFormData.append("CheckOutDate", CheckOutDate);
                bodyFormData.append("NoOfDaysStayed", NoOfDays);
                bodyFormData.append("ExpenseAmount", ExpAmount);
                bodyFormData.append("ProjectCode", ProjectCode);
                bodyFormData.append("Remarks", Remarks);
                bodyFormData.append("UpperCeiling", UpperLimit);
                bodyFormData.append("CityType", CityType);
                fetchDataapprove("ExpMangt/ExpensesUpdateWeb", bodyFormData);
            }
        }
    }

    const Save = () => {
        //debugger;
        const bodyFormData = new FormData();
        bodyFormData.append("TravelRequestID", props.TravelRequestID);
        bodyFormData.append("ExpenseID", ExpenseID);
        if (Remarks != '') {
            bodyFormData.append("ApproverRemarks", Remarks);
        } else {
            bodyFormData.append("ApproverRemarks", "");
            // if (BtnType == "Rej") {
            // setlabel14(true);
            // return;
            // }
        }
        // if (ApproveAmmount != '') {
        bodyFormData.append("ApprovalAMT", ApproveAmt);
        // } else {
        //     // if (BtnType == "Apv") {
        //     setlabel15(true);
        //     return;
        //     // }
        // }
        bodyFormData.append("ApprovedByID", Session.get("UID"));
        fetchDataapprove("ExpMangt/ExpApproval", bodyFormData);
    }



    const PopulateExpenseType = () => {
        debugger;
        var bodyFormData = new FormData();
        fetchExpTypeData("Primary/cmbExpenseType", bodyFormData);
    }

    const PopulateModeOfTravel = () => {
        debugger;
        var bodyFormData = new FormData();
        fetchModeOfTravel("Primary/cmbTravelMode", bodyFormData);
    }

    const DeleteExpense = () => {
        debugger;
        const bodyFormData = new FormData();
        if (props.ExpenseID !== "" && props.ExpenseID !== null) {
            bodyFormData.append("ExpenseID", props.ExpenseID);
            fetchDataReject("ExpMangt/DeleteExpenseWeb", bodyFormData);
        }
        else {
            alert('Please Select Expense.');
        }
    }

    const handleUploadClick = (event) => {
        debugger;
        try {
            debugger;
            getAttachements();
            var Type;
            if (event.target.name === "Attachment 1") {
                Type = "Attachment1"
            } else if (event.target.name === "Attachment 2") {
                Type = "Attachment2"
            } else if (event.target.name === "Attachment 3") {
                Type = "Attachment3"
            }
            var file = event.target.files[0];
            var FName = file.name;
            var FileExtension = file.name.split('.')[1];
            var Base64 = null;
            var base64Data;
            const reader = new FileReader();
            var url = reader.readAsDataURL(file);
            reader.onloadend = function (e) {
                setSelectedpdf([reader.result]);
                Base64 = [reader.result];
                base64Data = Base64[0].split(",")[1]
                setMainState("uploaded")
                if (MainState === "uploaded") {
                    setPdfUploaded(1);
                    setSelectedpdf(event.target.files[0])
                }
                uploadImage(base64Data, Type, FName, FileExtension);
            };
            getAttachements();

        } catch (error) {
            console.log(error);
        }

    }

    const uploadImage = async (data, Attachmentno, FName, FileExtension) => {
        debugger;
        DeleteFile(Attachmentno)
        var Type;
        if (FileExtension == "jpg") {
            Type = "Image";
        } else if (FileExtension == "pdf") {
            Type = "PDF";
        }
        const bodyFormData = new FormData();
        var Udata = data;
        console.log("File", Udata);
        var st = "";
        bodyFormData.append("App", "App");
        bodyFormData.append("attachmentNo", Attachmentno);
        bodyFormData.append("ExpenseID", ExpenseID);
        bodyFormData.append("TravelRequestID", props.TravelRequestID);
        bodyFormData.append("EmpID", Session.get("UID"));
        bodyFormData.append("Base64Image", Udata);
        bodyFormData.append("FileName", FName);
        bodyFormData.append("Type", Type);
        bodyFormData.append("FileExtension", FileExtension);
        fetchDataFile("ExpMangt/UploadImageNew", bodyFormData);
    };

    const DeleteFile = (Attachmentno) => {
        var id = ""
        if (Attachmentno == "Attachment1") {
            id = At1ID
        }
        else if (Attachmentno == "Attachment2") {
            id = At2ID
        }
        else if (Attachmentno == "Attachment3") {
            id = At3ID
        }
        if (id !== null) {
            const bodyFormData = new FormData();
            bodyFormData.append("ExpenseID", ExpenseID);
            bodyFormData.append("AttachmentsID", id);
            bodyFormData.append("TravelRequestNo", TravelRequestNo)
            fetchdeleteFile("ExpMangt/DeleteFile", bodyFormData);
        }
    }

    const ExpenseTypeData = (options) => {
        debugger;
        if (options !== undefined) {
            let ExpenseType = options.map((data) => (
                <option key={data.ExpenseType} value={data.ExpenseTypeID}>
                    {data.ExpenseType}
                </option>
            ));
            setExpenseTypecmb(ExpenseType);
        }
    };

    const ModeOfTravelData = (options) => {
        debugger;
        if (options !== undefined) {
            let ModeOfTravel = options.map((data) => (
                <option key={data.ModeOfTravel} value={data.ModeOfTravelID}>
                    {data.ModeOfTravel}
                </option>
            ));
            setModeOfTravelcmb(ModeOfTravel);
        }
    };

    const CityTypeData = () => {
        let CityType = CityTypeOptions.map((data) => (
            <option key={data.key} value={data.value}>
                {data.key}
            </option>
        ));
        return CityType;
    };
    useEffect(() => {
        debugger;
        if (responseattachment !== undefined && responseattachment.length > 0) {
            for (var i = 0; i < responseattachment.length; i++) {
                debugger;
                if (responseattachment[i].FileName.toString() == "Attachment1") {

                    setAt1URL(responseattachment[i].ServerFilePath)
                    setAt1(true);
                    setAt1ID(responseattachment[i].AttachmentsID)
                }
                if (responseattachment[i].FileName == "Attachment2") {
                    setAt2URL(responseattachment[i].ServerFilePath)
                    setAt2ID(responseattachment[i].AttachmentsID)
                }
                if (responseattachment[i].FileName == "Attachment3") {
                    setAt3URL(responseattachment[i].ServerFilePath)
                    setAt3ID(responseattachment[i].AttachmentsID)
                }
            }

            // setAT1File((responseattachment[0].ServerFilePath));
            // setAT2File((responseattachment[0].At2FServerFilePathile));
            // setAT3File((responseattachment[0].AtServerFilePath3File));
        }
    }, [responseattachment]);

    const SaveExpense = (value) => {
        debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("TravelRequestID", value.TravelRequestID);
        bodyFormData.append("EmpID", Session.get("UID"));
        bodyFormData.append("ExpenseID", value.id);

        if (value.AccountsRemarks !== null && value.AccountsRemarks !== "") {
            bodyFormData.append("AccountsRemarks", value.AccountsRemarks);
        } else {
            bodyFormData.append("AccountsRemarks", "");
        }
        if (value.AccountsApprovedAmt !== null && value.AccountsApprovedAmt !== "") {
            if (!isNaN(+value)) {
                alert('Please Enter Numeric Value only !..');
                return;
            }
            else {
                bodyFormData.append("AccountsApprovedAmt", value.AccountsApprovedAmt);
            }
        } else {

            alert('Please Enter Accounts Approved Amount !...');
            return;
        }

        AccApfetchData("Dashboard/ExpAccApproval", bodyFormData);
    }

    useEffect(() => {
        //debugger;
        poppopupData();
        popupGrid();
        PopulateExpenseType();
        PopulateModeOfTravel();
        console.log("pagename", props.pagename);
    }, [])

    useEffect(() => {
        debugger;
        if (responseExpType !== undefined) {

            if (responseExpType !== undefined) {
                ExpenseTypeData(responseExpType);
            }
        }
    }, [responseExpType]);

    useEffect(() => {
        debugger;
        if (responseModeOfTravel !== undefined) {

            if (responseModeOfTravel !== undefined) {
                ModeOfTravelData(responseModeOfTravel);
            }
        }
    }, [responseModeOfTravel]);

    useEffect(() => {
        debugger;
        if (ModeOfTravelID == "108d33d1-7c43-11ed-8023-42010aa00007" || ModeOfTravelID == "3eb328c0-7c43-11ed-8023-42010aa00007") {
            setDisableKM(false);
        } else {
            setDisableKM(true);
        }
    }, [ModeOfTravelID]);


    useEffect(() => {
        debugger;
        var Amount;
        if (ModeOfTravelID == "108d33d1-7c43-11ed-8023-42010aa00007") {
            Amount = 12 * Distance;
            setExpAmount(Amount);
        } else if (ModeOfTravelID == "3eb328c0-7c43-11ed-8023-42010aa00007") {
            Amount = 5 * Distance;
            setExpAmount(Amount);
        }
    }, [Distance]);




    useEffect(() => {
        debugger;
        console.log(responseApprove.Response);
        if ((responseApprove.Response === true)) {
            alert('Data Saved Succesfully.');
            props.setOpen(false);
            props.PopulateData();
        }
        else if (responseApprove.Response === false) {
            if (responseApprove.Message === "Expense date is not within the travel request period.") {
                alert('Expense date is not with in the travel request period.');
            } else if (responseApprove.Message === "DA Amount is not Approved") {
                alert('Amount is not Approved.');
            } else {
                alert('Failed to save data.');
            }
        }
    }, [responseApprove])

    useEffect(() => {
        //debugger;
        if ((responseReject.Response === true)) {
            alert('Data Deleted Successfully.');
            props.setOpen(false);
            props.ExpenseData();
        }
        else if (responseReject.Response === false) {
            alert('Failed.');
        }
    }, [responseReject])

    useEffect(() => {
        if (response01.Response == true) {
            //debugger;
            props.setOpen(false);
            props.PopulateData();
        }

    }, [response01])

    useEffect(() => {
        //debugger;
        const bodyFormData = new FormData();
        bodyFormData.append("ExpenseID", props.ExpenseID);
        bodyFormData.append("TravelRequestNo", props.TravelRequestID);
        attachmentfetchData("ExpMangt/GetAttachmentsWeb", bodyFormData);
    }, [])

    const getAttachements = () => {
        debugger;
        const bodyFormData = new FormData();
        bodyFormData.append("ExpenseID", props.ExpenseID);
        bodyFormData.append("TravelRequestNo", props.TravelRequestID);
        attachmentfetchData("ExpMangt/GetAttachmentsWeb", bodyFormData);
    }



    let CityTypecmb = CityTypeData();


    const submitForm = () => {
        if (pagename !== "Home") {
            const bodyFormData = new FormData();
            bodyFormData.append("TravelRequestID", props.TravelRequestID);
            bodyFormData.append("PaidOn", PaidOn);
            bodyFormData.append("TotalPaidAmount", TotalPaidAmount);
            bodyFormData.append("PaymentDetails", PaymentDetails);
            fetchData01("Dashboard/PaymentUpdate", bodyFormData);
        } else {
            const bodyFormData = new FormData();
            bodyFormData.append("TravelRequestID", props.TravelRequestID);
            bodyFormData.append("EmpID", Session.get("UID"));
            fetchData01("Dashboard/AccApproval", bodyFormData);
        }


    };

    const onSelectChange = (e) => {
        let targetvalue = e.target.value;
        let targetname = e.target.name;
        if (targetvalue !== "") {
            if (targetname === "ExpenseType") {
                setExpenseTypeID(targetvalue);

            }
        }

    }


    const OpenFile = (Atfiles) => {
        var data = ""
        getAttachements();
        if (Atfiles == "AT1") {
            data = At1URL
        } else if (Atfiles == "AT2") {
            data = At2URL
        } else if (Atfiles == "AT3") {
            data = At3URL
        }
        if (data != "" && data != null) {
            window.open(data);
        } else {
            alert('File Not Found.');
        }
    }


    const Print = () => {
        debugger;
        if (props.TravelRequestID != "" && props.TravelRequestID != null && props.TravelRequestID != undefined) {
            const bodyFormData = new FormData();
            bodyFormData.append("TravelRequestID", props.TravelRequestID);
            fetchDataprint("Dashboard/PDFGenerate", bodyFormData);
        }
    }
    useEffect(() => {
        debugger;
        if (responseprint != undefined && responseprint.length > 0) {
            window.open(responseprint[0].FileURL);
        }
    }, [responseprint])


    useEffect(() => {
        if (responseList !== undefined && responseList.length > 0) {
            debugger;
            setTravelRequestNo((responseList[0].TravelRequestNo));
            // setExpenseDate(moment(responseList[0].ExpenseDate).format('YYYY-MM-DD'));

            // For Expense Date and Time
            if(responseList[0].ExpenseDate) {
                const expDateTime = new Date(responseList[0].ExpenseDate);
                setExpenseDate(moment(expDateTime).format('YYYY-MM-DD'));
                setExpenseTime(moment(expDateTime).format('HH:mm'));
            }

            setUserName(responseList[0].EmpName);
            setLocationToTravel(responseList[0].LocationToTravel);
            setTravelFromLocation(responseList[0].LocationFromTravel);
            setPurposeOfTravel(responseList[0].PurposeOfTravel);
            setExpenseSheetCreatedOn(responseList[0].ExpenseSheetCreatedOn);
            setEmpName(responseList[0].EmpName);
            setApprovedBy(responseList[0].ApprovedBy);
            setPlannedAmount(responseList[0].ApproxExpAmount);
            setApprovedOn(responseList[0].ApprovedOn != null && responseList[0].ApprovedOn != "" ? moment(responseList[0].ApprovedOn).format('YYYY-MM-DD') : null);
            setApproxExpAmt(responseList[0].ApproxExpAmount);
            settolExpAppAmount(responseList[0].TotalApprovedAmount);
            settolAccAppAmount(responseList[0].TotalAccAppAmt);
            setPaidOn(responseList[0].PaidOn != null && responseList[0].PaidOn != "" ? moment(responseList[0].PaidOn).format('YYYY-MM-DD') : null);
            setTotalPaidAmount(responseList[0].TotalPaidAmount);
            setPaymentDetails(responseList[0].PaymentDetails);
            setStatus(responseList[0].ApprovalStatus);
            setFromDate(responseList[0].FromDate != null && responseList[0].FromDate != "" ? moment(responseList[0].FromDate).format('YYYY-MM-DD') : null);
            setToDate(responseList[0].ToDate != null && responseList[0].ToDate != "" ? moment(responseList[0].ToDate).format('YYYY-MM-DD') : null);
            if (responseList[0].ApprovalStatus == "Travelling") {
                setflag01(true);
                setflag(false);
                setDelflag(false);
            } else {
                setDelflag(true);
            }
            if (responseList[0].ApprovalStatus != "TR Approved" && responseList[0].ApprovalStatus != "Exp Approval" && responseList[0].ApprovalStatus != "Travelling") {
                setSaveflag(true);
            } else {
                setSaveflag(false);
            }
            setApprovalStatus(responseList[0].ApprovalStatus);
            setDescription(responseList[0].Description);
            setExpenseType(responseList[0].ExpenseType);
            setExpenseTypeID(responseList[0].ExpenseTypeID);
            setCityType(responseList[0].CityType);
            setCheckInDate(responseList[0].CheckInDate != null && responseList[0].CheckInDate != "" ? moment(responseList[0].CheckInDate).format('YYYY-MM-DD') : null);
            setCheckOutDate(responseList[0].CheckOutDate != null && responseList[0].CheckOutDate != "" ? moment(responseList[0].CheckOutDate).format('YYYY-MM-DD') : null);
            setTravelMode(responseList[0].ModeOfTravel);
            setTravelFrom(responseList[0].TravelFrom);
            setTravelTo(responseList[0].TravelTo);
            setDistance(responseList[0].DistanceTravelledInKm);
            // setTime(responseList[0].TimeTakenInHrs);

            // For Time Reached
            if(responseList[0].TimeTakenInHrs) {
                const timeReached = new Date(responseList[0].TimeTakenInHrs);
                setTime(moment(timeReached).format('YYYY-MM-DD'));
                setTimeReached(moment(timeReached).format('HH:mm'));
            }

            setExpAmount(responseList[0].ExpenseAmount);
            setUpperLimit(responseList[0].UpperCeiling);
            setApproveAmt(responseList[0].ApprovedAmt);
            setProjectCode(responseList[0].ProjectCode);
            setRemarks(responseList[0].Remarks)
            setNoOfDays(responseList[0].NoOfDaysStayed);
            setModeOfTravelID(responseList[0].ModeOfTravelID);
            console.log("Expense Typeid: ", responseList[0].ExpenseTypeID)


        } else {
            if (props.Status != "TR Approved" && props.Status != "Exp Approval" && props.Status != "Travelling") {
                setSaveflag(true);
            } else {
                setSaveflag(false);
            }
        }
    }, [props.Status, responseList]);


    const openPath = (row) => {
        debugger;
        window.open(row.formattedValue);

    };





    return (<div>
        <Formik initialValues={{
            TravelRequestNo: TravelRequestNo, ExpenseDate: ExpenseDate, EmpID: EmpID, TravelFrom: TravelFrom, ModeOfTravelID: ModeOfTravelID,
            ApprovedBy: ApprovedBy, ApprovedOn: ApprovedOn, AccApprovedBy: AccApprovedBy, AccApprovedOn: AccApprovedOn, PlannedAmount: PlannedAmount, tolExpAmount: tolExpAmount,
            PaidOn: PaidOn, PaidAmount: PaidAmount, PaymentDetails: PaymentDetails, CheckInDate: CheckInDate, CheckOutDate: CheckOutDate, CityType: CityType
        }} validationSchema={validationSchema}
            //onSubmit={() => submitForm()}
            onSubmit={onSubmit}
            enableReinitialize>
            {formik => {
                return <Form>
                    <Grid item xs={12} spacing={1} container direction="row">
                        <Grid item xs={12} spacing={1} container direction="row">
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                                <label
                                    htmlFor={"ExpenseDate"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Date : "}
                                </label>
                            </Grid>
                            {/* {<Grid item xs={6} sm={6} md={6} lg={6}>
                                <BiztranControlsFormik
                                    control="input"
                                    type="date"
                                    name="ExpenseDate"
                                    //disabled={true}
                                    //value={ExpenseDate}
                                    onChange={(e) => setExpenseDate(e.target.value)}
                                />
                            </Grid>} */}
                            <Grid item xs={6}>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <BiztranControlsFormik
                                            control="input"
                                            type="date"
                                            name="ExpenseDate"
                                            value={ExpenseDate}
                                            onChange={(e) => {
                                                setExpenseDate(e.target.value)
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <BiztranControlsFormik
                                            control="input" 
                                            type="time"
                                            name="ExpenseTime"
                                            value={ExpenseTime}
                                            onChange={(e) => {
                                                setExpenseTime(e.target.value)
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                                <label
                                    htmlFor={"EmpID"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Expense Type: "}
                                </label>
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                                <BiztranControlsFormik
                                    control="select"
                                    name="ExpenseType"
                                    // ref={ref}
                                    value={ExpenseTypeID}
                                    options={ExpenseTypecmb}
                                    // onChange={(e) => {
                                    //     setExpenseType(e.target.value)
                                    //     // handleChange()
                                    // }}
                                    onChange={onSelectChange}
                                />
                            </Grid>

                        </Grid>


                        {ExpenseTypeID == '6688b64f-4b7e-11ed-ad55-42010aa00007' || ExpenseTypeID == '4a61f883-4b7e-11ed-ad55-42010aa00007'
                            || ExpenseTypeID == '3b06fd98-4b7e-11ed-ad55-42010aa00007' || ExpenseTypeID == '18f3120b-6eee-11ed-8023-42010aa00007' ?
                            <Grid item xs={12} spacing={1} container direction="row">
                                <Grid item xs={6}>
                                    <label
                                        htmlFor={"City"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"City : "}
                                    </label>
                                </Grid>
                                <Grid item xs={6} >
                                    <BiztranControlsFormik
                                        control="select"
                                        name="CityType"
                                        // ref={ref}
                                        options={CityTypecmb}
                                        onChange={(e) => {
                                            setCityType(e.target.value)
                                            // handleChange()
                                        }}
                                    //onChange={onSelectChange}
                                    />
                                </Grid>
                            </Grid>

                            : null}


                        {/* {ExpenseTypeID == '3b06fd98-4b7e-11ed-ad55-42010aa00007' || ExpenseTypeID == '18f3120b-6eee-11ed-8023-42010aa00007' ?
                            <Grid item xs={12} spacing={1} container direction="row">
                                <Grid item xs={6}>
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"From Date : "}
                                    </label>
                                </Grid>
                                <Grid item xs={6} >
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            // display: "block",
                                            fontWeight: "bold",
                                            width: "100%",
                                        }}
                                    >
                                        {FromDate}
                                    </label>
                                </Grid>
                            </Grid>

                            : null} */}

                        {ExpenseTypeID == '4a61f883-4b7e-11ed-ad55-42010aa00007' ?
                            <Grid item xs={12} spacing={1} container direction="row">
                                <Grid item xs={6}>
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Check In Date : "}
                                    </label>
                                </Grid>
                                <Grid item xs={6} >
                                    <BiztranControlsFormik
                                        control="input"
                                        type="date"
                                        name="CheckInDate"
                                        //disabled={true}
                                        //value={TravelRequestDate}
                                        onChange={(e) => setCheckInDate(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Check out Date : "}
                                    </label>
                                </Grid>
                                <Grid item xs={6} >
                                    <BiztranControlsFormik
                                        control="input"
                                        type="date"
                                        name="CheckOutDate"
                                        //disabled={true}
                                        //value={TravelRequestDate}
                                        onChange={(e) => setCheckOutDate(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Number of Days : "}
                                    </label>
                                </Grid>
                                <Grid item xs={6} >
                                    <BiztranControlsFormik
                                        autoFocus="autofocus"
                                        control="input"
                                        type="text"
                                        name="NoOfDays"
                                        //ref={ref}
                                        value={NoOfDays}
                                        //options={ASIcmb}                   
                                        onChange={(e) => {
                                            setNoOfDays(e.target.value)
                                            //handleChange()
                                        }}
                                    />
                                </Grid>
                            </Grid>

                            : null}


                        {ExpenseTypeID == '3b06fd98-4b7e-11ed-ad55-42010aa00007' || ExpenseTypeID == '18f3120b-6eee-11ed-8023-42010aa00007' ?
                            <Grid item xs={12} spacing={1} container direction="row">
                                <Grid item xs={6}>
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Mode of travel : "}
                                    </label>
                                </Grid>
                                <Grid item xs={6} >
                                    <BiztranControlsFormik
                                        control="select"
                                        name="ModeOfTravelID"
                                        // ref={ref}

                                        options={ModeOfTravelcmb}
                                        onChange={(e) => {
                                            setModeOfTravelID(e.target.value)
                                            // handleChange()
                                        }}
                                    //onChange={onSelectChange}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"From Location : "}
                                    </label>
                                </Grid>
                                <Grid item xs={6} >
                                    <BiztranControlsFormik
                                        autoFocus="autofocus"
                                        control="input"
                                        type="text"
                                        name="TravelFrom"
                                        //ref={ref}
                                        value={TravelFrom}
                                        //options={ASIcmb}                   
                                        onChange={(e) => {
                                            setTravelFrom(e.target.value)
                                            //handleChange()
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"To Location : "}
                                    </label>
                                </Grid>
                                <Grid item xs={6} >
                                    <BiztranControlsFormik
                                        autoFocus="autofocus"
                                        control="input"
                                        type="text"
                                        name="TravelTo"
                                        //ref={ref}
                                        value={TravelTo}
                                        //options={ASIcmb}                   
                                        onChange={(e) => {
                                            setTravelTo(e.target.value)
                                            //handleChange()
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Distance In KM : "}
                                    </label>
                                </Grid>
                                <Grid item xs={6} >
                                    <BiztranControlsFormik
                                        autoFocus="autofocus"
                                        control="input"
                                        type="text"
                                        name="Distance"
                                        disabled={DisableKM}
                                        value={Distance}
                                        //options={ASIcmb}                   
                                        onChange={(e) => {
                                            setDistance(e.target.value)
                                            //handleChange()
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <label
                                        htmlFor={"ApprovedBy"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {/* {"Time Taken In Hours : "} */}
                                        {"Time Reached : "}
                                    </label>
                                </Grid>
                                {/* {<Grid item xs={6} >
                                    <BiztranControlsFormik
                                        autoFocus="autofocus"
                                        control="input"
                                        type="text"
                                        name="Time"
                                        //ref={ref}
                                        value={Time}
                                        //options={ASIcmb}                   
                                        onChange={(e) => {
                                            setTime(e.target.value)
                                            //handleChange()
                                        }}
                                    />
                                </Grid>} */}

                                <Grid item xs={6}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={6}>
                                            <BiztranControlsFormik
                                                control="input"
                                                type="date"
                                                name="Time"
                                                value={Time}
                                                onChange={(e) => {
                                                    setTime(e.target.value)
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <BiztranControlsFormik
                                                control="input"
                                                type="time"
                                                name="TimeReached"
                                                value={TimeReached}
                                                onChange={(e) => {
                                                    setTimeReached(e.target.value)
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Grid>

                            : null}

                        <Grid item xs={12} spacing={1} container direction="row">

                            <Grid item xs={6}>
                                <label
                                    htmlFor={"ApproxExpAmt"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Expense Amount :"}
                                </label>
                            </Grid>
                            <Grid item xs={6} >
                                <BiztranControlsFormik
                                    autoFocus="autofocus"
                                    control="input"
                                    type="text"
                                    name="ExpAmount"
                                    //ref={ref}
                                    value={ExpAmount}
                                    //options={ASIcmb}                   
                                    onChange={(e) => {
                                        setExpAmount(e.target.value)
                                        //handleChange()
                                    }}
                                />
                            </Grid>


                            <Grid item xs={6}>
                                <label
                                    htmlFor={"tolExpAmount"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Upper Limit :"}
                                </label>
                            </Grid>
                            <Grid item xs={6} >
                                <BiztranControlsFormik
                                    autoFocus="autofocus"
                                    control="input"
                                    type="text"
                                    name="UpperLimit"
                                    //ref={ref}
                                    value={UpperLimit}
                                    //options={ASIcmb}                   
                                    onChange={(e) => {
                                        setUpperLimit(e.target.value)
                                        //handleChange()
                                    }}
                                />
                            </Grid>


                        </Grid>
                        <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
                            <Grid item xs={4} >
                                {/* <a href="javascript:;" onClick={() => { OpenFile("AT1"); }}  >Attachment 1</a> */}
                                <input type='file'
                                    onChange={handleUploadClick}
                                    name="Attachment 1"
                                // className={classes.input}
                                //id={ props.id }   multiple   
                                />

                            </Grid>
                            <Grid item xs={4} >
                                <input type='file'
                                    onChange={handleUploadClick}
                                    name="Attachment 2"
                                // className={classes.input}
                                //id={ props.id }   multiple   
                                />

                            </Grid>
                            <Grid item xs={4} >
                                <input type='file'
                                    onChange={handleUploadClick}
                                    name="Attachment 3"
                                // className={classes.input}
                                //id={ props.id }   multiple   
                                />

                            </Grid>

                        </Grid>

                        <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
                            <Grid item xs={4} style={{ display: At1URL ? "inline" : "none" }}>
                                <a href="javascript:;" onClick={() => { OpenFile("AT1"); }}  >Attachment 1</a>

                            </Grid>
                            <Grid item xs={4} style={{ display: At2URL ? "inline" : "none" }}>
                                <a href="javascript:;" onClick={() => { OpenFile("AT2"); }} >Attachment 2</a>

                            </Grid>
                            <Grid item xs={4} style={{ display: At3URL ? "inline" : "none" }}>
                                <a href="javascript:;" onClick={() => { OpenFile("AT3"); }} >Attachment 3</a>

                            </Grid>

                        </Grid>

                        {/* <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
                            <Grid item xs={4}>
                                <label
                                    htmlFor={"PaymentDetails"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Approve Amount :"}
                                </label>
                            </Grid>
                            <Grid item xs={8} >
                                <BiztranControlsFormik
                                    autoFocus="autofocus"
                                    control="input"
                                    type="text"
                                    name="ReasonToRejection"
                                    //ref={ref}
                                    value={ApproveAmt}
                                    //options={ASIcmb}                   
                                    onChange={(e) => {
                                        setApproveAmt(e.target.value)
                                        //handleChange()
                                    }}
                                />

                            </Grid>
                        </Grid> */}

                        <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
                            <Grid item xs={4}>
                                <label
                                    htmlFor={"PaymentDetails"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Project Code :"}
                                </label>
                            </Grid>
                            <Grid item xs={8} >
                                <BiztranControlsFormik
                                    autoFocus="autofocus"
                                    control="input"
                                    type="text"
                                    name="ProjectCode"
                                    //ref={ref}
                                    value={ProjectCode}
                                    //options={ASIcmb}                   
                                    onChange={(e) => {
                                        setProjectCode(e.target.value)
                                        //handleChange()
                                    }}
                                />

                            </Grid>
                        </Grid>




                        <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
                            <Grid item xs={4}>
                                <label
                                    htmlFor={"PaymentDetails"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Remarks :"}
                                </label>
                            </Grid>
                            <Grid item xs={8} >
                                <BiztranControlsFormik
                                    autoFocus="autofocus"
                                    control="input"
                                    type="text"
                                    name="ReasonToRejection"
                                    //ref={ref}
                                    value={Remarks}
                                    //options={ASIcmb}                   
                                    onChange={(e) => {
                                        setRemarks(e.target.value)
                                        //handleChange()
                                    }}
                                />

                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <div style={{ width: '100%' }}>
                                <div style={{ display: 'flex', marginTop: 5, justifyContent: 'center', alignContent: "center" }}>

                                    <BiztranControls.Button
                                        text="Save"
                                        startIcon={<SaveIcon />}
                                        //onClick={submitApprove}
                                        onClick={onSubmit}
                                        disabled={saveflag}
                                    //type="submit"
                                    />

                                    <BiztranControls.Button
                                        text="Delete"
                                        startIcon={<SaveIcon />}
                                        onClick={DeleteExpense}
                                        disabled={Delflag}


                                    />

                                </div>
                            </div>
                        </Grid>
                    </Grid>


                </Form>
            }}
        </Formik>

    </div >)

}
export default AddExpense;